export default {
    getterSelectedStoreName: ({ storeDetail }) => storeDetail?.validatedStoreName,
};
